var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"vue-product-favorite"},[_c('button',{staticClass:"btn-ghost btn-favorite",class:{'favorite': _setup.isFavorite},attrs:{"disabled":_setup.loading},on:{"click":_setup.handleClick}},[[_c('dentaid-favorite-icon')]],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }